import { SxProps, Theme } from "@mui/material";

export const eyebrow: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  fontSize: "0.7rem",
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  color: "#38bdf8",
};

export const gradientText: SxProps<Theme> = {
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 55%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const sectionTitle: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 700,
  fontSize: { xs: "1.1rem", md: "1.3rem" },
  color: "white",
  pb: 1.5,
  mb: 3,
  borderBottom: "1px solid rgba(56,189,248,0.15)",
};

export const bodyText: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  fontSize: "1rem",
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.8,
  mb: 2,
};

export const emailLink: SxProps<Theme> = {
  color: "#38bdf8",
  textDecoration: "none",
  "&:hover": { textDecoration: "underline" },
};

export const glass: SxProps<Theme> = {
  background: "rgba(255,255,255,0.03)",
  backdropFilter: "blur(16px)",
  border: "1px solid rgba(56,189,248,0.12)",
  borderRadius: "20px",
  p: { xs: 3, md: 4 },
};

export const heroSection: SxProps<Theme> = {
  minHeight: "50vh",
  background: "#040922",
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
};

export const heroGradient: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "radial-gradient(ellipse 60% 50% at 50% 40%, rgba(56,189,248,0.07) 0%, transparent 70%)",
  pointerEvents: "none",
};

export const heroTitle: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 800,
  fontSize: { xs: "2.8rem", md: "4.5rem" },
  lineHeight: 1.1,
  letterSpacing: "-0.03em",
  mb: 3,
};

export const heroDate: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  fontSize: "0.9rem",
  color: "rgba(255,255,255,0.4)",
};

export const heroFade: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: "120px",
  background: "linear-gradient(to bottom, transparent 0%, #080f1e 100%)",
  pointerEvents: "none",
};

export const summaryGrid: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: 2,
  mb: 8,
};

export const summaryTermTitle: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 700,
  fontSize: "0.95rem",
  color: "white",
  mb: 1,
};

export const tocTitle: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 700,
  fontSize: "1rem",
  color: "white",
  mb: 3,
};

export const tocNumber: SxProps<Theme> = {
  color: "#38bdf8",
  fontFamily: "'Barlow'",
  fontSize: "0.9rem",
  flexShrink: 0,
};

export const tocItemText: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  fontSize: "0.9rem",
  color: "rgba(255,255,255,0.7)",
};

export const addressBlock: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  fontSize: "0.95rem",
  color: "rgba(255,255,255,0.82)",
  lineHeight: 2,
};
